export default (editor, opts) => {
  const dc = editor.DomComponents;
  const { type, label, projectId } = opts;
  const defaultType = dc.getType('default');
  const defaultModel = defaultType.model;
  const defaultView = defaultType.view;

  dc.addType(type, {
    model: defaultModel.extend(
      {
        defaults: {
          ...defaultModel.prototype.defaults,
          'custom-name': label,
          projectId: projectId,
          droppable: false, // Can't drop other elements inside
          icon: '<i class="wb webconnect-chat-dots"></i>',
          traits: [],
          script: function () {
            const projectId = '{[ projectId ]}';
            const messageOptions = { projectId };
            if (typeof loadChatComponent !== 'undefined') {
              loadChatBotMessageComponent(this, messageOptions);
            }
          },
        },
        init() {},
      },
      {
        isComponent(el) {
          if (el.getAttribute && el.getAttribute('data-gjs-type') === type) {
            return {
              type: type,
            };
          }
        },
      },
    ),
    view: defaultView.extend({
      init({ model }) {
        // this.listenTo(model, 'change:finderUuid', this.updateScript);
      },
    }),
  });
};
